module.exports = __webpack_public_path__ + "static/7-0bdb333bffaa40a142cba6aa6eff7d63.jpeg";